import { ReactComponent as SupervisionImage } from "assets/images/supervision.svg";
import { useMessageContext } from "providers/MessageProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledButton,
  StyledHeading,
  StyledInnerContainer,
  TextContainer,
} from "./styles";

const Supervision: React.FC = () => {
  const { t } = useTranslation();
  const { isFormVisible, isFormSuccessVisible, onShowForm } =
    useMessageContext();

  return (
    <StyledInnerContainer isVisible={!isFormSuccessVisible}>
      <SupervisionImage
        role="img"
        aria-labelledby={
          t("10719") /* Fiscalização de estacionamentos na palma da mão */
        }
        title={t("10719") /* Fiscalização de estacionamentos na palma da mão */}
      />
      <div className="ml-30">
        <TextContainer isFormVisible={isFormVisible}>
          <StyledHeading variant="h5" elementType="h3">
            {t("10170") /* A fiscalização em tempo real! */}
          </StyledHeading>
          <StyledHeading variant="h6" elementType="h4" className="mt-10">
            {t("10171") /* Deixe-nos a sua mensagem para mais informações. */}
          </StyledHeading>
        </TextContainer>
        <StyledButton
          color="secondary"
          className="mt-20"
          onClick={onShowForm}
          isFormVisible={isFormVisible}
        >
          {t("6357") /* Enviar mensagem */}
        </StyledButton>
      </div>
    </StyledInnerContainer>
  );
};

export default Supervision;
